import React from 'react';
import { Link } from '@/components/LocaleLink';
import { useLanguage } from '@/contexts/language/LanguageContext';

const CTASection = () => {
  const { t } = useLanguage();
  
  return (
    <section className="py-20">
      <div className="container-custom max-w-5xl mx-auto relative">
        {/* Orange gradient background with rounded corners - same width as Consulting */}
        <div className="absolute inset-0 bg-gradient-to-br from-[#FF6B35] via-[#FF7F27] to-[#FF4500] rounded-3xl" />
        <div className="relative z-10 max-w-3xl mx-auto text-center py-12 px-4">
          {/* Headline */}
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 text-white leading-tight">
            {t('ctaTitle')}
          </h2>
          
          {/* Subtitle */}
          <p className="text-lg md:text-xl text-white mb-10 max-w-xl mx-auto">
            {t('ctaSubtitle')}
          </p>
          
          {/* Single button */}
          <div className="flex justify-center">
            <Link
              to="/tell-me-more"
              className="inline-flex items-center justify-center px-8 py-4 rounded-lg bg-[#3F2E5C] hover:bg-[#3F2E5C]/90 text-white text-base font-medium transition-all duration-300 shadow-lg border border-white/10"
            >
              {t('contactUs')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
